// export default function (context, data ) {
//     console.info("save changed setting: changedSetting: ", data.changedSetting, " index: ", data.index);
//     context.commit('change_settings', data);
// }


import axios from 'axios'

export default function ({state, commit, dispatch}, settingData) {
    return new Promise(resolve => {


        var bodyFormData = new FormData();
        bodyFormData.append('Setting', JSON.stringify(settingData.changedSetting));

        if (settingData.image) {
          bodyFormData.append('Image', settingData.image);
        }

        axios({
            method: 'post',
            url: '/tourclient/Settings/PaymentIntegrationSetting',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(
            ({data}) => {
                commit('change_settings', data.Setting);
                /*if (data) {
                    commit('settings', data.Settings);
                }*/
                commit('resolves');
                commit('loading', false);
                dispatch('get');
            },
            err => {
                commit('resolves');
                commit('loading', false);
                dispatch('error', err, {root: true});
            }
        );
    })
}